import { useEffect, useState } from 'react';

import { EmailOutlined } from '@mui/icons-material';
import { TextField, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { usePostHog } from 'posthog-js/react';
import { useSelector } from 'react-redux';

import Dialog from '@/components/Dialog';
import { METADATA_FIRST_NAME_FIELD, METADATA_LAST_NAME_FIELD } from '@/constants/constants';
import { retrieveFromUserMetadata } from '@/utils/retrieveFromUserMetadata';

import { RootState } from '../../store';

const PremiumDialog = ({
  open,
  onClose,
  type
}: {
  open: boolean;
  onClose: () => void;
  type?: string;
}) => {
  const [value, setValue] = useState('');
  const [messageSent, setMessageSent] = useState(false);
  const { metadata, userEmail } = useSelector((state: RootState) => state.auth);

  useEffect(
    () => () => {
      setTimeout(() => {
        setMessageSent(false);
        setValue('');
      }, 1000);
    },
    [open]
  );

  const premiumMessage = 'Premium';
  const enterpriseMessage = 'Enterprise';

  const firstName = retrieveFromUserMetadata(metadata || [], METADATA_FIRST_NAME_FIELD);
  const lastName = retrieveFromUserMetadata(metadata || [], METADATA_LAST_NAME_FIELD);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const posthog = usePostHog();
  const handleAction = () => {
    if (messageSent) {
      handleClose();
      return;
    }
    setMessageSent(true);
    posthog?.capture('premium_enquire_sent', {
      additionalInfo: value
    });
  };

  return (
    <Dialog
      actionButtonText={
        messageSent ? (
          'Close'
        ) : (
          <>
            <EmailOutlined />
            Send
          </>
        )
      }
      handleAction={handleAction}
      handleClose={handleClose}
      hasCancelButton={!messageSent}
      open={open}
      sx={{ zIndex: 1402 }}
      text={
        messageSent ? (
          <>
            <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 0.7 }}>Message sent!</Typography>
            <Typography sx={{ mt: 2 }}>Thank you.</Typography>
            <Typography>We'll be in touch shortly!</Typography>
          </>
        ) : (
          <>
            <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 0.7 }}>Get in touch</Typography>
            <Typography sx={{ fontWeight: 700, mb: 0.7 }}>
              {firstName} {lastName}
            </Typography>
            {userEmail && <Typography sx={{ fontWeight: 700 }}>{userEmail}</Typography>}
            <Paper sx={{ p: 1.5, my: 2, fontSize: 14 }}>
              Hi,
              <br />
              Can you tell me more about GX Go{' '}
              {type === 'enterprise' ? enterpriseMessage : premiumMessage}?
            </Paper>
            <TextField
              fullWidth
              hiddenLabel
              multiline
              minRows={2}
              placeholder='(Optional) Enter any additional information'
              value={value}
              variant='outlined'
              onChange={e => {
                setValue(e.target.value);
              }}
            />
          </>
        )
      }
    />
  );
};

export default PremiumDialog;
